<template>
  <!-- 

  enter="tw:duration-0 tw:ease-out"
    enter-from="tw:opacity-0"
    enter-to="tw:opacity-100"
    leave="tw:duration-0 tw:ease-in"
    leave-from="tw:opacity-100"
    leave-to="tw:opacity-0"

 -->
  <TransitionRoot
    appear
    :show="showMe"
    @before-enter="beforeEnter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @after-leave="afterLeave"
  >
    <Dialog
      class="tw:fixed tw:inset-0 tw:z-10 tw:overflow-y-auto"
      @close="handleClose"
    >
      <div
        ref="dialogRef"
        class="
          tw:flex
          tw:items-center
          tw:justify-center
          tw:min-h-screen
          tw:font-helvetica
        "
      >
        <DialogOverlay
          class="
            tw:fixed tw:inset-0 tw:bg-black tw:opacity-80 tw:transition-all
          "
        />
        <slot>
          <!-- Use this as content -->
          <div class="tw-card tw:mx-4 tw:my-8 tw:max-w-md">
            <div class="tw-card-head">
              <h4>Title</h4>
            </div>
            <div class="tw-card-body">
              <p>Description</p>

              <p>
                Are you sure you want to sdeactivate your account? All of your
                data will be permanently removed. This action cannot be undone.
              </p>
            </div>
            <div class="tw-footer">
              <button @click="handleClose">Deactivate</button>
              <button @click="handleClose">Cancel</button>
            </div>
          </div>
        </slot>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { ref, watch } from "vue";
import { Dialog, DialogOverlay, TransitionRoot } from "@headlessui/vue";
export default {
  components: {
    Dialog,
    DialogOverlay,
    TransitionRoot,
  },
  props: ["show", "handleClose"],
  setup(props) {
    const showMe = ref(false);
    const dialogRef = ref(null);

    setTimeout(() => {
      showMe.value = true;
    }, 0);

    watch(dialogRef, (element, prevElement) => {
      if (element) {
        dialogRef.value = element;
      }
    });

    const beforeEnter = () => {
      if (dialogRef.value) {
        dialogRef.value.classList.add("tw:opacity-0");
        dialogRef.value.classList.add("tw:transition-all");
        dialogRef.value.classList.add("tw:duration-300");
        dialogRef.value.classList.add("tw:ease-out");
      }
    };

    const afterEnter = () => {
      if (dialogRef.value) {
        dialogRef.value.classList.add("tw:opacity-100");
        dialogRef.value.classList.add("tw:transition-all");
        dialogRef.value.classList.add("tw:duration-300");
        dialogRef.value.classList.remove("tw:opacity-0");
      }
    };

    const beforeLeave = () => {
      if (dialogRef.value) {
        dialogRef.value.classList.remove("tw:duration-300");
        dialogRef.value.classList.add("tw:duration-500");
        dialogRef.value.classList.add("tw:opacity-100");
      }
    };

    const afterLeave = (e) => {
      if (dialogRef.value) {
        dialogRef.value.classList.add("tw:opacity-0");
        dialogRef.value.classList.remove("tw:opacity-100");
        dialogRef.value.classList.remove("tw:ease-out");
        dialogRef.value.classList.add("tw:ease-in");
      }
    };

    return {
      showMe,
      beforeEnter,
      afterEnter,
      beforeLeave,
      afterLeave,
      dialogRef,
    };
  },
};
</script>
